import { render } from "./Loan_Classifications.vue?vue&type=template&id=d6296934"
import script from "./Loan_Classifications.vue?vue&type=script&lang=js"
export * from "./Loan_Classifications.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__